import { handleTokenUrl } from '@/utils/tool'

const urlInfo = {
  apiUrl: null,
  websocketUrl: null,
  liveUrl: null,
  csUrl: null
}
const permissionInfo = {
  register_need_phone: null,
  email_need_verify: null,
  enable_show_terms: null,
  terms_message: null,
  mobile_force_app: 0,
  pop_announcement: null,
  enable_google_login: null
}
const webInfo = {
  show_vip_rebate: 1
}
const brand = {
  state: {
    info: '',
    appInfo: false,
    urlInfo: urlInfo,
    permissionInfo: permissionInfo,
    searchKeyWord: [],
    brandImage: null,
    readTerms: false,
    readAnnouncement: false,
    supportPhoneCode: [],
    supportNationality: [],
    webInfo: webInfo,
    quickBars: [],
    banners: [],
    theme: '',
    showSearch: false,
    showProvider: false,
    currency: '',
    fcmToken: '',
    carousel: [],
    marqueeDatail: null,
    googleOauthId: null
  },
  mutations: {
    SET_BRAND_INFO: (state, info) => {
      if (info) {
        state.info = info.brandInfo
        state.urlInfo = info.urlInfo
        state.appInfo = info.appInfo
        state.brandImage = info.brandImage
        state.searchKeyWord = info.searchKeyword
        if (state.permissionInfo.pop_announcement !== info.permissionInfo.pop_announcement) {
          state.readAnnouncement = false
        }
        state.permissionInfo = info.permissionInfo
        state.googleOauthId = info.google_oauth_id || null
        state.webInfo.show_vip_rebate = info.webInfo.show_vip_rebate
      }
    },
    SET_READ_TERMS: (state, data) => {
      state.readTerms = data
    },
    SET_READ_ANNOUNCEMENT: (state, data) => {
      state.readAnnouncement = data
    },
    SET_SUPPORT_PHONE_CODE: (state, data) => {
      state.supportPhoneCode = data
    },
    SET_SUPPORT_NATIONALITY: (state, data) => {
      state.supportNationality = data || []
    },
    SET_BRAND_IMAGE: (state, data) => {
      state.brandImage = data
    },
    SET_URLINFO_CSURL: (state, data) => {
      state.urlInfo.csUrl = data
    },
    SET_QUICKBARS: (state, data) => {
      state.quickBars = data
    },
    SET_BANNERS: (state, data) => {
      state.banners = data
    },
    SET_THEME(state, theme) {
      state.theme = theme
    },
    SET_SHOW_RESEARCH(state, value) {
      state.showSearch = value
    },
    SET_SHOW_PROVIDER(state, value) {
      state.showProvider = value
    },
    SET_CURRENCY(state, value) {
      state.currency = value
    },
    SET_FCM_TOKEN(state, value) {
      state.fcmToken = value
    },
    SET_CAROUSEL(state, value) {
      state.carousel = value
    },
    SET_MARQUEE_DETAIL(state, value) {
      state.marqueeDatail = value
    }
  },
  actions: {
    // 登入
    UpdateCsUrl(store) {
      if (store.state.urlInfo.csUrl) {
        store.commit('SET_URLINFO_CSURL', handleTokenUrl(store.state.urlInfo.csUrl, store.getters.token))
      }
    }
  }
}

export default brand
